/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Scope of a permission.
 */
export type PermissionScope =
  (typeof PermissionScope)[keyof typeof PermissionScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionScope = {
  all: 'all',
  specific: 'specific',
  own: 'own',
} as const;
